module.exports = __webpack_public_path__ + "img/Simple-Burger.4997891e.png";